import { render, staticRenderFns } from "./VisualButton.vue?vue&type=template&id=367de01e&scoped=true&"
import script from "./VisualButton.vue?vue&type=script&lang=js&"
export * from "./VisualButton.vue?vue&type=script&lang=js&"
import style0 from "./VisualButton.vue?vue&type=style&index=0&id=367de01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367de01e",
  null
  
)

export default component.exports